module.exports = __webpack_public_path__ + "static/media/colorful.4f2d1ec2.png";